import { CircularProgress } from "@mui/material";
import Button from "components/UI/Button";
import Checkbox from "components/UI/Checkbox";
import FlexboxContainerComponent from "components/UI/FlexboxContainer";
import InputComponent from "components/UI/Input";
import { TEXT_LABELS } from "constants/order";
import React from "react";
import { Background, Main, Shade } from "styles/themeColors";

interface MDMNumberSetupProps {
    disabled?: boolean;
    validateMDMNumber: () => void;
    isAutomaticCreditCheckEnabled?: boolean;
    enableAutomaticCreditCheck: (value: boolean) => void;
    mdmNumber?: string;
    setMdmNumber?: (value: string) => void;
    mdmErrorMessage?: string;
    setMdmErrorMessage?: (value: string) => void;
    isVerifying?: boolean;
}

const MDMNumberSetup: React.FC<MDMNumberSetupProps> = ({
    disabled,
    validateMDMNumber,
    isAutomaticCreditCheckEnabled,
    enableAutomaticCreditCheck,
    mdmNumber,
    setMdmNumber,
    mdmErrorMessage,
    setMdmErrorMessage,
    isVerifying
}) => {
    const handleCheckboxChange = (value: boolean) => {
        enableAutomaticCreditCheck(value);
        if (!value) {
            setMdmNumber?.('');
            setMdmErrorMessage?.('');
        }
    };

    return (
        <FlexboxContainerComponent flexDirection="column" gap="5px">
            <FlexboxContainerComponent flexDirection="column">
                <span>{TEXT_LABELS.MDM_MANAGED_MANUALLY}</span>
                <span>{TEXT_LABELS.SO_WONT_CREATE_AUTOMATICALLY}</span>
                <span>{TEXT_LABELS.WOULD_YOU_LIKE_TO_ENABLE_AUTOMATED_CC}<i> {TEXT_LABELS.MDM_NUMBER_REQUIRED}</i></span>
            </FlexboxContainerComponent>
            <Checkbox
                id={''}
                name={TEXT_LABELS.ENABLE_AUTOMATED_CC}
                label={TEXT_LABELS.ENABLE_AUTOMATED_CC}
                checked={isAutomaticCreditCheckEnabled}
                appearance="none"
                checkboxSize="s"
                onChange={(value: boolean) => handleCheckboxChange(value)}
                theme={'brandLight'}
                bgColor={Main.brandLight}
                labelPosition="right"
                disabled={isVerifying}
            />
            {
                isAutomaticCreditCheckEnabled && (
                    <FlexboxContainerComponent gap="8px" margin="0px 0px 10px 0px">
                        <InputComponent
                            id="mdm-number"
                            name="mdm-number"
                            type="text"
                            placeholder="Enter MDM Number"
                            disabled={disabled || isVerifying}
                            margin="10px 0 0 0"
                            value={mdmNumber!}
                            onChange={(e: any) => { setMdmNumber?.(e.target.value); setMdmErrorMessage?.(''); }}
                            labelName="MDM Number"
                            labelPosition="top"
                            errorMessage={mdmErrorMessage}
                            isInvalid={!!mdmErrorMessage}
                            isOptional
                            showOptional={false}
                            width="400px"
                            labelText={mdmErrorMessage ? "" : TEXT_LABELS.PLEASE_PROVIDE_MDM_NUMBER}
                        />
                        <Button
                            onClick={validateMDMNumber}
                            isGhost
                            color={Background.navy}
                            borderColor={Shade.shade550}
                            margin="38px 0px 0px 0px"
                            disabled={disabled || isVerifying || !mdmNumber}
                        >
                            {isVerifying ?
                                <FlexboxContainerComponent gap="5px">
                                    {isVerifying ? <CircularProgress size="16px" style={{ color: Background.navy }} /> : null}
                                    <span>Verifying</span>
                                </FlexboxContainerComponent> :
                                "Apply"
                            }
                        </Button>
                    </FlexboxContainerComponent>
                )
            }
        </FlexboxContainerComponent>
    );
};

export default MDMNumberSetup;